import React from 'react';
import { authRoles, PERMISSION } from 'app/auth';
import i18next from 'i18next';
import { MENU_ENUM } from 'app/main/role/constants';
import en from '../i18n/en';

i18next.addResourceBundle('en', 'patientGroup', en);

const CreatePatientGroupConfig = {
  settings: {
    layout: {
      config: {},
    },
    nav: {
      title: 'Create Patient Group',
    },
  },
  auth: authRoles.user,
  key: MENU_ENUM.PATIENT_GROUP,
  permission: PERMISSION.CREATE,
  routes: [
    {
      path: '/patient-group/create',
      component: React.lazy(() => import('./CreatePatientGroup')),
    },
  ],
};

export default CreatePatientGroupConfig;
